import { Chip, Container, HeaderBar, Tabs, TypoGraph } from 'components'
import { useState } from 'react'
import { fleetReportingTabs } from 'constants/status'
import styles from './fleetReporting.module.scss'
import FleetHeartbeat from './fleetHeartbeat'
import FleetPercentiles from './fleetPercentiles'
import FleetDetailsForAgents from 'pages/carriers/partial/fleetDetailsForAgent'
import FleetMilesByZipDashboard from 'pages/carriers/partial/fleetMilesByZip'
import moment from 'moment'

interface IFleetDetailProps { }

const FleetReporting: React.FC<IFleetDetailProps> = (props) => {
    const [fleetReportingTab, setFleetReportingTab] = useState(0)
    const reportingTitle = 'Fleet Reporting'

    let riskEldObject: any = {}

    const TabPanel = (props: { print: boolean }) => {
        const { print } = props
        switch (fleetReportingTab) {
            case 0:
                return <FleetHeartbeat print={print} />
            case 1:
                return <FleetPercentiles print={print} />
            case 2:
                return <FleetDetailsForAgents print={print} />
            case 3:
                return <FleetMilesByZipDashboard print={print} useCarrierFilters={false} />
            default:
                return <FleetHeartbeat print={print} />
        }
    }

    const getPageMargins = () => {
        return `@page { margin: 30px!important; }`
    }

    return (
        <Container className={styles.fleetReportingContainer}>
            <Container className={styles.headerContainer}>
                <Container className={styles.headerTitleContainer}>
                    <TypoGraph
                        variant="h1"
                        sx={{ marginRight: '1rem' }}
                        mb={0}
                        content={reportingTitle}
                    />
                    <Chip
                        label={`Updated ${moment(riskEldObject?.updated).format('dddd, MMMM Do')}`}
                        variant="filled"
                        sx={{
                            backgroundColor: '#E1FAEB',
                            color: '#20693D',
                        }}
                    />
                </Container>
            </Container>
            <Tabs
                tabData={fleetReportingTabs}
                value={fleetReportingTab}
                id={fleetReportingTabs[fleetReportingTab].label}
                handleChange={(_e, val) => setFleetReportingTab(val)}
                sxContainer={{
                    marginLeft: '1rem',
                }}
            />
            <Container>
                <TabPanel print={false} />
            </Container>
            <style>{getPageMargins()}</style>
        </Container>
    )
}

export default FleetReporting